import { toHTML } from "@portabletext/to-html";
import { TableProps } from "@bluebottlecoffee/design-system/components";
import { Table as Schema } from "../sanity-schema";
import { Dialect } from "../utils/locale";

export function toTableProps(data: Schema, lang: Dialect["lang"]): TableProps {
  return {
    caption: data.caption[lang],
    columnHeaders: data.columnHeaders.map((header) => toHTML(header[lang])),
    rows: data.rows.map((row) => ({
      columns: row.columns.map((column) => toHTML(column[lang])),
    })),
  };
}
